import { StatusIndicator } from '@/components/ui/status-indicator.tsx'

interface Props {
  state: 'DONE' | 'IN_PROGRESS'
}

const colorClassNames: Record<Props['state'], string> = {
  DONE: 'bg-green-500',
  IN_PROGRESS: 'bg-yellow-500',
}

const statusMessages: Record<Props['state'], string> = {
  DONE: 'Done',
  IN_PROGRESS: 'In progress...',
}

export const MessageQueueIndicator = ({ state }: Props) => {
  const colorClassName = colorClassNames[state]
  const statusMessage = statusMessages[state]

  return (
    <StatusIndicator
      colorClassName={colorClassName}
      tooltipContent={statusMessage}
      size="small"
      pulse={state === 'IN_PROGRESS'}
    />
  )
}
